import { SportRecordDetailPathSchema } from '@school-manage/schema/path.schema';
import { createFileRoute } from '@tanstack/react-router';

import { SportRecordDetailError } from './-components/error/SportRecordDetailError';
import { SportRecordDetailSkeleton } from './-components/pending/SportRecordDetailSkeleton';
import { SportRecordDetail } from './-components/SportRecordDetail';
import { useSportRecordDetail } from './-logic/useSportRecordDetail';
import { SportRecordDetailContext } from './-logic/useSportRecordDetailContext';

export const Route = createFileRoute('/_authed/record/$recordId/form')({
  component: FormRecordDetailPage,
  errorComponent: SportRecordDetailError,
  params: { parse: SportRecordDetailPathSchema.parse },
  pendingComponent: SportRecordDetailSkeleton,
});

function FormRecordDetailPage() {
  return (
    <SportRecordDetailContext.Provider value={useSportRecordDetail()}>
      <SportRecordDetail />
    </SportRecordDetailContext.Provider>
  );
}
